import { APP_ROUTES } from "@shared/constants/app-routes.constants";
import { ENRICHMENT_MODES, EnrichmentMode } from "./enrichment-mode.model";

const escapeRegExp = (text: string) =>
  text.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&");

const underRoot = (root: string) =>
  new RegExp(`^${escapeRegExp(root)}(?=[/?#]|$)`);

export function rebaseEnrichmentUrl(
  url: string,
  from: EnrichmentMode,
  to: EnrichmentMode,
): string {
  return url.replace(
    underRoot(ENRICHMENT_MODES[from].root),
    ENRICHMENT_MODES[to].root,
  );
}

/** The sidebar has one Enrichment entry, at the current mode's root, so a
 *  price-mode path is read as its current-mode twin when marking it active,
 *  and the package editor both modes open counts as Enrichment too. */
export function enrichmentMenuPath(path: string): string {
  return rebaseEnrichmentUrl(path, "price", "current").replace(
    underRoot(APP_ROUTES.MANAGEMENT.ENRICHMENT_PACKAGE.ROOT),
    ENRICHMENT_MODES.current.root,
  );
}
